var text_field_default = {
  "root": "QwG6L",
  "text": "j-qw4",
  "input": "ntg-k",
  "small": "X-pcj",
  "medium": "Mtrd1",
  "large": "cTYv0",
  "webview": "OHQ5j",
  "endAdornment": "y4-6h",
  "shown": "R3V0-",
  "value": "vtASJ",
  "spinner": "tDiVg",
  "spin": "KPImI"
};
export {
  text_field_default as default
};
//# sourceMappingURL=text-field-scss.js.map
